import UIStore from "../../store/uiStore";
import ChatStore from "../../store/chatStore";
import UserAuthStore from "../../store/userStore";
import FileUploadStore from "../../store/fileUploadStore";
import useSessionIdStore from "../../store/useSessionIdStore";
import useModelStore from "../../store/useModelStore";
import useHeaderSelectedAIModel from "../../store/useHeaderSelectedAIModel";
import AGENT_CONFIG from "../../agent_configs";
import api, { queryClient } from "../../api";
import ENDPOINTS from "../../api/endpoints";
import logger from "../../services/Logger";
import QUERYKEYS, { chatModelInfoQueryKey } from "../../api/queryKeys";
import { broadcastInvalidate } from "../../api/broadcastSync";

const addChat = async (space, isNewChat, agent, chat, prompt = "", chatId) => {
  const { user, email, orgId } = UserAuthStore.getState();
  if (!isNewChat) return;
  // if (agent?.name) {
  // Debug agent information
  // console.log(agent);
  //   return;
  // }

  try {
    const { setActiveChat } = ChatStore.getState();
    const { setInputFileName, setFileSize, setFileUrl, setShowUpload } =
      FileUploadStore.getState();

    const { modeRef } = UIStore.getState();
    const explicitModelId = chatId
      ? useModelStore.getState().selectedModels[chatId] || null
      : null;
    const selectedHeaderModel = useHeaderSelectedAIModel.getState().selectedModel;
    const explicitModelName =
      explicitModelId && selectedHeaderModel?.id === explicitModelId
        ? selectedHeaderModel.name || selectedHeaderModel.display_name || null
        : null;

    const RemoveUpload = () => {
      setInputFileName([]);
      setFileSize([]);
      setFileUrl([]);
      setShowUpload(false);
    };

    RemoveUpload();
    // Seed the doc title with the user's first words (like ChatGPT/Claude) so
    // the sidebar shows a meaningful default immediately instead of flashing a
    // generic "New Chat" until backend title generation lands. Falls back to
    // "New Chat" only when there's no prompt text.
    const defaultTitle = (prompt || "").trim().substring(0, 50) || "New Chat";
    let data = {};
    if (agent?.name) {
      data = {
        uid: user?.uid,
        user_id: user?.uid,
        email: "",
        title: defaultTitle,
        asset_ids: [],
        agent_name: agent?.name,
        agent_id: agent?.name,
        space: null,
        pinned: false,
        pinned_date: null,
        mode: "global",
        timestamp: null,
        updated_at: null,
        model_id: AGENT_CONFIG?.DEFAULT_AGENT_MODEL?.model_id || 'default-model',
        model_name: AGENT_CONFIG?.DEFAULT_AGENT_MODEL?.model_name || 'Default Model',
      };
    } else {
      data = {
        uid: chatId,
        user_id: space
          ? space?.owner_id
          : chat?.owner_id
          ? chat?.owner_id
          : user?.uid,
        email: email,
        title: defaultTitle,
        asset_ids: [],
        space: space?.space_id ? space.space_id : null,
        agent_id: agent?.name || null,
        agent_name: agent?.name || null,
        pinned: false,
        pinned_date: null,
        mode: modeRef,
        timestamp: null,
        updated_at: null,
        model_id: explicitModelId,
        owner_id: space ? space?.owner_id : chat?.owner_id ? chat?.owner_id : user?.uid,
        collaborator: [],
        model_name: explicitModelName,
      };
    }

    const ownerId = space ? space?.owner_id : chat?.owner_id ? chat?.owner_id : user?.uid;
    const session_id = useSessionIdStore.getState().session_id;

    await api({
      method: "POST",
      url: ENDPOINTS.CREATE_SPARK,
      data: {
        chat_id: chatId,
        org_id: orgId,
        owner_id: ownerId,
        chat_data: data,
        space_id: space?.space_id ?? null,
        session_id,
      },
    });

    queryClient.setQueryData(
      chatModelInfoQueryKey(chatId, space?.space_id),
      (current) => ({
        ...current,
        uid: chatId,
        ...(explicitModelId
          ? {
              model_id: explicitModelId,
              persisted_model_id: explicitModelId,
              ...(explicitModelName
                ? {
                    model_name: explicitModelName,
                    persisted_model_name: explicitModelName,
                  }
                : {}),
            }
          : {}),
      })
    );

    setActiveChat(chatId);

    if (agent?.name) return chatId;

    if (space?.space_id) {
      const qk = ['spectra-sparks', space.space_id, orgId, user?.uid, space.owner_id];
      queryClient.invalidateQueries({ queryKey: qk });
      broadcastInvalidate(qk);
      // Also flush personal spark cache so sub-sparks don't bleed into Spark section
      queryClient.invalidateQueries({ queryKey: [QUERYKEYS.CHATS, orgId, user?.uid] });
    } else {
      const qk = [QUERYKEYS.CHATS, orgId, user?.uid];
      queryClient.invalidateQueries({ queryKey: qk });
      broadcastInvalidate(qk);
    }
    return chatId;
  } catch (error) {
    logger.error('addChat', 'Error creating spark', { err: error?.message, orgId, userId: user?.uid });
  }
};

export default addChat;
